import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { MODAL_HIDE, USER_SET_ETH_ADDRESS } from '../../../constants/action-types';

class UserSetEthAddress extends Component {
    constructor(props) {
        super(props);
    }

    submitETHAddress() {

        this.props.userSetEthAddress(this.refs.inputField.value)
        this.props.closeModal()

    }

    render() {
        return (
            <div className="flex flex-column">
               <h4 style={{margin: '1rem 0 2rem'}}>Set your ETH address to receive tokens!</h4>
               <input type='text' placeholder="Set ETH address" ref='inputField'/>
                <button className='primary' onClick={this.submitETHAddress.bind(this)}>
                    <div className='flex'>
                        <small>Set ETH address</small>
                    </div>
                </button>
            </div>);
    }
}

const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({
    userSetEthAddress: (address) => { dispatch({ type: USER_SET_ETH_ADDRESS, payload: address }) },
    closeModal: () => dispatch({ type: MODAL_HIDE })
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserSetEthAddress)


// WEBPACK FOOTER //
// ./src/components/templates/modals/user-set-eth-address.js